import { FontWeights, FontStyles, FontFormats } from '../types/index.js';

const fontFamilyName = 'Picsart-Fonts';
const GilroyFontThinUrls = {
    normal: {
        eot: 'https://cdn140.picsart.com/52293301763295768589.eot',
        ttf: 'https://cdn140.picsart.com/28852979007415371430.ttf',
        svg: 'https://cdn140.picsart.com/15924717846613778546.svg',
        woff: 'https://cdn140.picsart.com/38281535162655980605.woff',
        woff2: 'https://cdn140.picsart.com/66639402799341365665.woff2',
    },
    italic: {
        eot: 'https://cdn140.picsart.com/26285594657841694099.eot',
        ttf: 'https://cdn140.picsart.com/36989343163149417765.ttf',
        svg: 'https://cdn140.picsart.com/48452111767650772556.svg',
        woff: 'https://cdn140.picsart.com/95132097997672780006.woff',
        woff2: 'https://cdn140.picsart.com/49126424799030180537.woff2',
    },
};
const GilroyFontExtraLightUrls = {
    normal: {
        eot: 'https://cdn140.picsart.com/15491438650782864682.eot',
        ttf: 'https://cdn140.picsart.com/06571825812647057245.ttf',
        svg: 'https://cdn140.picsart.com/53123065836579363702.svg',
        woff: 'https://cdn140.picsart.com/49935397778933361391.woff',
        woff2: 'https://cdn140.picsart.com/39345958867651457730.woff2',
    },
    italic: {
        eot: 'https://cdn140.picsart.com/97303278251285599062.eot',
        ttf: 'https://cdn140.picsart.com/77657406910941316530.ttf',
        svg: 'https://cdn140.picsart.com/98595272389079478069.svg',
        woff: 'https://cdn140.picsart.com/33301619378285557787.woff',
        woff2: 'https://cdn140.picsart.com/64323524026727032265.woff2',
    },
};
const GilroyFontLightUrls = {
    normal: {
        eot: 'https://cdn140.picsart.com/61615988446090353328.eot',
        ttf: 'https://cdn140.picsart.com/09192708899395495105.ttf',
        svg: 'https://cdn140.picsart.com/99768155936732255537.svg',
        woff: 'https://cdn140.picsart.com/95331006284270664783.woff',
        woff2: 'https://cdn140.picsart.com/70508065077428789025.woff2',
    },
    italic: {
        eot: 'https://cdn140.picsart.com/15628858373057370326.eot',
        ttf: 'https://cdn140.picsart.com/50166575908966566878.svg',
        svg: 'https://cdn140.picsart.com/37237791007875551178.ttf',
        woff: 'https://cdn140.picsart.com/49759505544048891136.woff',
        woff2: 'https://cdn140.picsart.com/78466976049360945564.woff2',
    },
};
const GilroyFontRegularUrls = {
    normal: {
        eot: 'https://cdn140.picsart.com/83707857368748793331.eot',
        ttf: 'https://cdn140.picsart.com/02128548520060315482.ttf',
        svg: 'https://cdn140.picsart.com/35335469030649130297.svg',
        woff: 'https://cdn140.picsart.com/67495207039426567603.woff',
        woff2: 'https://cdn140.picsart.com/43823716564166265631.woff2',
    },
    italic: {
        eot: 'https://cdn140.picsart.com/23659464016547540757.eot',
        ttf: 'https://cdn140.picsart.com/61621296748437955632.ttf',
        svg: 'https://cdn140.picsart.com/84355008111828542317.svg',
        woff: 'https://cdn140.picsart.com/15219032925171359633.woff',
        woff2: 'https://cdn140.picsart.com/08532218230872496735.woff2',
    },
};
const GilroyFontMediumUrls = {
    normal: {
        eot: 'https://cdn140.picsart.com/22508834374254079014.eot',
        ttf: 'https://cdn140.picsart.com/31085940595801585166.ttf',
        svg: 'https://cdn140.picsart.com/54590976909535751491.svg',
        woff: 'https://cdn140.picsart.com/21141070680110120308.woff',
        woff2: 'https://cdn140.picsart.com/67914239187346587316.woff2',
    },
    italic: {
        eot: 'https://cdn140.picsart.com/50583071805581702167.eot',
        ttf: 'https://cdn140.picsart.com/31741091656581762489.ttf',
        svg: 'https://cdn140.picsart.com/76349953520852902259.svg',
        woff: 'https://cdn140.picsart.com/61093264704757982896.woff',
        woff2: 'https://cdn140.picsart.com/82712100789938804480.woff2',
    },
};
const GilroyFontSemiBoldUrls = {
    normal: {
        eot: 'https://cdn140.picsart.com/73337678746129463785.eot',
        ttf: 'https://cdn140.picsart.com/40233543784144613684.ttf',
        svg: 'https://cdn140.picsart.com/32953439209893675340.svg',
        woff: 'https://cdn140.picsart.com/11783960151644825438.woff',
        woff2: 'https://cdn140.picsart.com/88499198308846124996.woff2',
    },
    italic: {
        eot: 'https://cdn140.picsart.com/43507088709286286596.eot',
        ttf: 'https://cdn140.picsart.com/13310509850662454457.ttf',
        svg: 'https://cdn140.picsart.com/00192774796132163918.svg',
        woff: 'https://cdn140.picsart.com/25120219760730098498.woff',
        woff2: 'https://cdn140.picsart.com/75935471303344975336.woff2',
    },
};
const GilroyFontBoldUrls = {
    normal: {
        eot: 'https://cdn140.picsart.com/97806602463765364827.eot',
        ttf: 'https://cdn140.picsart.com/21817749730864229129.ttf',
        svg: 'https://cdn140.picsart.com/23496574717428482539.svg',
        woff: 'https://cdn140.picsart.com/29363190554400305654.woff',
        woff2: 'https://cdn140.picsart.com/99194016167001679582.woff2',
    },
    italic: {
        eot: 'https://cdn140.picsart.com/41304520465216719753.eot',
        ttf: 'https://cdn140.picsart.com/27684725786923748782.ttf',
        svg: 'https://cdn140.picsart.com/99341867591302152085.svg',
        woff: 'https://cdn140.picsart.com/88259155622864238943.woff',
        woff2: 'https://cdn140.picsart.com/48552049507639887229.woff2',
    },
};
const GilroyFontExtraBoldUrls = {
    normal: {
        eot: 'https://cdn140.picsart.com/32956316314133304609.eot',
        ttf: 'https://cdn140.picsart.com/72791191975358016354.ttf',
        svg: 'https://cdn140.picsart.com/16880906488625272893.svg',
        woff: 'https://cdn140.picsart.com/09299983129684434707.woff',
        woff2: 'https://cdn140.picsart.com/81192957029258005704.woff2',
    },
    italic: {
        eot: 'https://cdn140.picsart.com/90954333409912710264.eot',
        ttf: 'https://cdn140.picsart.com/22331822496306757054.ttf',
        svg: 'https://cdn140.picsart.com/05848916009314342297.svg',
        woff: 'https://cdn140.picsart.com/47088833008701832357.woff',
        woff2: 'https://cdn140.picsart.com/68412285889232005274.woff2',
    },
};
const GilroyFontBlackUrls = {
    normal: {
        eot: 'https://cdn140.picsart.com/20330399298376893152.eot',
        ttf: 'https://cdn140.picsart.com/55075480012850244408.ttf',
        svg: 'https://cdn140.picsart.com/41840617729025291131.svg',
        woff: 'https://cdn140.picsart.com/53910000588793157256.woff',
        woff2: 'https://cdn140.picsart.com/87821703128058655354.woff2',
    },
    italic: {
        eot: 'https://cdn140.picsart.com/95736726502977864366.eot',
        ttf: 'https://cdn140.picsart.com/89152743934159655874.ttf',
        svg: 'https://cdn140.picsart.com/79443337000199234455.svg',
        woff: 'https://cdn140.picsart.com/77918190375531961686.woff',
        woff2: 'https://cdn140.picsart.com/90436717488837371347.woff2',
    },
};
const GilroyFontHeavyUrls = {
    normal: {
        eot: 'https://cdn140.picsart.com/64775025022096929077.eot',
        ttf: 'https://cdn140.picsart.com/70268119994214007722.ttf',
        svg: 'https://cdn140.picsart.com/49107957091095061221.svg',
        woff: 'https://cdn140.picsart.com/95612227858248821755.woff',
        woff2: 'https://cdn140.picsart.com/23727583559134230022.woff2',
    },
    italic: {
        eot: 'https://cdn140.picsart.com/38281089248161193867.eot',
        ttf: 'https://cdn140.picsart.com/08664538939053791723.ttf',
        svg: 'https://cdn140.picsart.com/89672124852354081600.svg',
        woff: 'https://cdn140.picsart.com/14948005683107720847.woff',
        woff2: 'https://cdn140.picsart.com/01762284817722241268.woff2',
    },
};
const GilroyFontUrls = {
    [FontWeights.Thin]: {
        ...GilroyFontThinUrls,
    },
    [FontWeights.ExtraLight]: {
        ...GilroyFontExtraLightUrls,
    },
    [FontWeights.Light]: {
        ...GilroyFontLightUrls,
    },
    [FontWeights.Regular]: {
        ...GilroyFontRegularUrls,
    },
    [FontWeights.Medium]: {
        ...GilroyFontMediumUrls,
    },
    [FontWeights.SemiBold]: {
        ...GilroyFontSemiBoldUrls,
    },
    [FontWeights.Bold]: {
        ...GilroyFontBoldUrls,
    },
    [FontWeights.ExtraBold]: {
        ...GilroyFontExtraBoldUrls,
    },
    [FontWeights.Black]: {
        ...GilroyFontBlackUrls,
    },
    [FontWeights.Heavy]: {
        ...GilroyFontHeavyUrls,
    },
};
const GilroyFonts = [
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Normal,
        fontWeight: FontWeights.Thin,
        fallbacks: [
            { src: 'local("Gilroy-Thin")' },
            { src: `url("${GilroyFontUrls[FontWeights.Thin].normal.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.Thin].normal.woff2}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Italic,
        fontWeight: FontWeights.Thin,
        fallbacks: [
            { src: 'local("Gilroy-ThinItalic")' },
            { src: `url("${GilroyFontUrls[FontWeights.Thin].italic.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.Thin].italic.woff2}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Normal,
        fontWeight: FontWeights.ExtraLight,
        fallbacks: [
            { src: 'local("Gilroy-UltraLight")' },
            { src: `url("${GilroyFontUrls[FontWeights.ExtraLight].normal.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.ExtraLight].normal.woff}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Italic,
        fontWeight: FontWeights.ExtraLight,
        fallbacks: [
            { src: 'local("Gilroy-UltraLightItalic")' },
            { src: `url("${GilroyFontUrls[FontWeights.ExtraLight].italic.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.ExtraLight].italic.woff}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Normal,
        fontWeight: FontWeights.Light,
        fallbacks: [
            { src: 'local("Gilroy-Light")' },
            { src: `url("${GilroyFontUrls[FontWeights.Light].normal.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.Light].normal.woff2}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Italic,
        fontWeight: FontWeights.Light,
        fallbacks: [
            { src: 'local("Gilroy-LightItalic")' },
            { src: `url("${GilroyFontUrls[FontWeights.Light].italic.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.Light].italic.woff2}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Normal,
        fontWeight: FontWeights.Regular,
        fallbacks: [
            { src: 'local("Gilroy-Regular")' },
            { src: `url("${GilroyFontUrls[FontWeights.Regular].normal.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.Regular].normal.woff2}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Italic,
        fontWeight: FontWeights.Regular,
        fallbacks: [
            { src: 'local("Gilroy-RegularItalic")' },
            { src: `url("${GilroyFontUrls[FontWeights.Regular].italic.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.Regular].italic.woff2}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Normal,
        fontWeight: FontWeights.Medium,
        fallbacks: [
            { src: 'local("Gilroy-Medium")' },
            { src: `url("${GilroyFontUrls[FontWeights.Medium].normal.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.Medium].normal.woff2}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Italic,
        fontWeight: FontWeights.Medium,
        fallbacks: [
            { src: 'local("Gilroy-MediumItalic")' },
            { src: `url("${GilroyFontUrls[FontWeights.Medium].italic.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.Medium].italic.woff2}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Normal,
        fontWeight: FontWeights.SemiBold,
        fallbacks: [
            { src: 'local("Gilroy-SemiBold")' },
            { src: `url("${GilroyFontUrls[FontWeights.SemiBold].normal.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.SemiBold].normal.woff}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Italic,
        fontWeight: FontWeights.SemiBold,
        fallbacks: [
            { src: 'local("Gilroy-SemiBoldItalic")' },
            { src: `url("${GilroyFontUrls[FontWeights.SemiBold].italic.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.SemiBold].italic.woff}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Normal,
        fontWeight: FontWeights.Bold,
        fallbacks: [
            { src: 'local("Gilroy-Bold")' },
            { src: `url("${GilroyFontUrls[FontWeights.Bold].normal.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.Bold].normal.woff}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Italic,
        fontWeight: FontWeights.Bold,
        fallbacks: [
            { src: 'local("Gilroy-BoldItalic")' },
            { src: `url("${GilroyFontUrls[FontWeights.Bold].italic.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.Bold].italic.woff2}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Normal,
        fontWeight: FontWeights.ExtraBold,
        fallbacks: [
            { src: 'local("Gilroy-ExtraBold")' },
            { src: `url("${GilroyFontUrls[FontWeights.ExtraBold].normal.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.ExtraBold].normal.woff2}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Italic,
        fontWeight: FontWeights.ExtraBold,
        fallbacks: [
            { src: 'local("Gilroy-ExtraBoldItalic")' },
            { src: `url("${GilroyFontUrls[FontWeights.ExtraBold].italic.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.ExtraBold].italic.woff2}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Normal,
        fontWeight: FontWeights.Black,
        fallbacks: [
            { src: 'local("Gilroy-Black")' },
            { src: `url("${GilroyFontUrls[FontWeights.Black].normal.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.Black].normal.woff2}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Italic,
        fontWeight: FontWeights.Black,
        fallbacks: [
            { src: 'local("Gilroy-BlackItalic")' },
            { src: `url("${GilroyFontUrls[FontWeights.Black].italic.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.Black].italic.woff2}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Normal,
        fontWeight: FontWeights.Heavy,
        fallbacks: [
            { src: 'local("Gilroy-Heavy")' },
            { src: `url("${GilroyFontUrls[FontWeights.Heavy].normal.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.Heavy].normal.woff2}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: fontFamilyName,
        fontStyle: FontStyles.Italic,
        fontWeight: FontWeights.Heavy,
        fallbacks: [
            { src: 'local("Gilroy-HeavyItalic")' },
            { src: `url("${GilroyFontUrls[FontWeights.Heavy].italic.woff}") format('${FontFormats.WOFF}')` },
            { src: `url("${GilroyFontUrls[FontWeights.Heavy].italic.woff2}") format('${FontFormats.WOFF2}')` },
        ],
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
];
function withFontFamily(params) {
    const systemFonts = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, Helvetica, Arabic, sans-serif";
    const fontFamily = params?.length ? `${fontFamilyName}, ${systemFonts}` : systemFonts;
    return {
        '@global': {
            html: {
                fontFamily,
            },
            '@font-face': params?.flat(),
        },
    };
}

export { FontFormats, FontStyles, FontWeights, GilroyFontBlackUrls, GilroyFontBoldUrls, GilroyFontExtraBoldUrls, GilroyFontExtraLightUrls, GilroyFontHeavyUrls, GilroyFontLightUrls, GilroyFontMediumUrls, GilroyFontRegularUrls, GilroyFontSemiBoldUrls, GilroyFontThinUrls, GilroyFontUrls, GilroyFonts, fontFamilyName, withFontFamily };
